import React, { useEffect } from 'react'

export default function CommonHead() {
    useEffect(() => {

        const headScripts = [
            // {
            //     src: `https://maps.googleapis.com/maps/api/js?sensor=false"`,
            //     async: false,
            //     defer: false,
            // },
            {
                src: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAP_KEY}&v=weekly&libraries=drawing,places,geometry`,
                async: false,
                defer: false,
            },
            {
                src: `https://polyfill.io/v3/polyfill.min.js?features=default`,
                async: false,
                defer: false,
            },
            {
                src: `https://unpkg.com/@google/markerclustererplus@4.0.1/dist/markerclustererplus.min.js`,
                async: false,
                defer: false,
            },
        ]

        headScripts.map((head, index) => {
            const script = document.createElement('script');
            script.src = head.src;
            script.defer = head.defer;
            document.body.appendChild(script);
            return () => { document.body.removeChild(script); }
        })

    }, []);
    return (null)
}
